import { createAction, props } from '@ngrx/store';
import { ProjectHICommMatrixModel } from '@shared/data-access/models';

export const getDetail = createAction('[PROJECT COMM MATRIX] GET DETAIL', props<{ item: ProjectHICommMatrixModel }>());
